import { useQuery } from '@tanstack/react-query';
import { customFetch } from '~/utils/customFetch';
import { useClientSessionQuery } from '../useSessionPlQuery';

export type AudiencePreference = {
  id: number;
  entityId: number;
  entityType: 'cohort' | 'audience';
  clientId: number;
  remoteUser: string;
  deletedAt: null;
  createdAt: string;
  updatedAt: string;
};

export type AudiencePreferencesResponse = {
  preferences: AudiencePreference[];
  success: boolean;
};

async function getAudiencePreferences(clientId?: number) {
  if (!clientId) {
    throw new Error('Client ID is required');
  }

  const { data } = await customFetch<AudiencePreferencesResponse>(
    `/authenticated/client/${clientId}/audiences/preferences`,
    {
      useNodeEndpoint: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return data.preferences;
}

export function useAudiencePreferenceQuery() {
  const { data: sessionData } = useClientSessionQuery();

  return useQuery(getAudiencePreferenceQueryOptions(sessionData?.id));
}

export function getAudiencePreferenceQueryOptions(clientId?: number) {
  return {
    queryKey: ['audiencePreferencesQuery', clientId],
    queryFn: () => getAudiencePreferences(clientId),
    enabled: !!clientId,
    staleTime: Infinity,
  };
}
